import React from 'react';
import { useIntl } from 'react-intl';
import { Tooltip } from '@eventbrite/marmalade';
import { PremiumOrganizerBadgeIcon } from '@/components/_shared/Icons';
import styles from './OrganizerNameWithBadge.module.scss';

interface OrganizerNameWithBadgeProps {
  name: string;
  isPremiumOrganizer: boolean;
}

// Renders the organizer name with the premium badge glued to the last word so it moves with the name.
export const OrganizerNameWithBadge: React.FC<OrganizerNameWithBadgeProps> = ({ name, isPremiumOrganizer }) => {
  const { formatMessage } = useIntl();
  const [isPremiumTooltipOpen, setIsPremiumTooltipOpen] = React.useState(false);

  if (!isPremiumOrganizer) {
    return <>{name}</>;
  }

  const nameWords = name.trim().split(/\s+/);
  const nameLastWord = nameWords[nameWords.length - 1];
  const namePrefix = nameWords.slice(0, -1).join(' ');

  return (
    <>
      {namePrefix && `${namePrefix} `}
      <span className={styles.premiumNameEnd}>
        {nameLastWord}
        <Tooltip
          content={formatMessage({
            id: 'This organizer has an Eventbrite Premium subscription.',
            defaultMessage: 'This organizer has an Eventbrite Premium subscription.',
            description: 'Premium organizer badge tooltip',
          })}
          className={styles.premiumTooltip}
          providerProps={{ delayDuration: 0 }}
          rootProps={{ open: isPremiumTooltipOpen, onOpenChange: setIsPremiumTooltipOpen }}
          contentProps={{ side: 'top', sideOffset: 6, avoidCollisions: false }}
        >
          <span
            className={styles.premiumBadge}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              setIsPremiumTooltipOpen((open) => !open);
            }}
            role="img"
            aria-label={formatMessage({
              id: 'Premium organizer',
              defaultMessage: 'Premium organizer',
              description: 'Accessible label for the premium organizer badge',
            })}
          >
            <PremiumOrganizerBadgeIcon />
          </span>
        </Tooltip>
      </span>
    </>
  );
};
